import { createFileRoute, redirect } from '@tanstack/react-router';

// Flows is home: a new organization's first screen is board 16's "No flows yet".
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/flows' });
  },
});
